// Nuvian · vente complémentaire (tiroir, page panier) : /cart/add.js + rendu de sections, voie de Dawn.
customElements.get('nuvian-cart-upsell') || customElements.define('nuvian-cart-upsell', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', (e) => this.onSubmit(e));
    if (this.hasAttribute('data-fetch')) this.load();
  }

  async load() {
    const { url, productId, limit } = this.dataset;
    if (!url || !productId) return;
    const inCart = this.dataset.inCart || '|';
    const max = parseInt(limit, 10) || 2;
    const picked = [];
    for (const intent of ['complementary', 'related']) {
      try {
        const res = await fetch(`${url}?section_id=nuvian-cart-upsell&product_id=${productId}&limit=8&intent=${intent}`);
        if (!res.ok) continue;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('.nv-upsell__item').forEach((li) => {
          const id = li.dataset.productId;
          if (picked.length < max && !inCart.includes(`|${id}|`) && !picked.some((p) => p.dataset.productId === id)) picked.push(li);
        });
      } catch (e) {
        /* réseau : le bloc reste masqué */
      }
      if (picked.length >= max) break;
    }
    if (!picked.length || !this.isConnected) return;
    this.querySelector('.nv-upsell__list')?.replaceChildren(...picked.map((li) => document.importNode(li, true)));
    this.hidden = false;
  }

  async onSubmit(e) {
    const form = e.target.closest('.nv-upsell__form');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('button');
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    form.querySelector('.loading__spinner')?.classList.remove('hidden');

    const drawer = document.querySelector('cart-drawer');
    const onPage = Boolean(this.closest('.nv-upsell-page')) || !drawer;
    const pageSections = onPage ? this.pageSections() : null;
    const sections = onPage ? pageSections.map((s) => s.section) : drawer.getSectionsToRender().map((s) => s.id);
    const id = parseInt(form.querySelector('[name="id"]').value, 10);

    try {
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const state = await res.json();
      if (!res.ok || state.status) throw new Error(state.description || state.message || 'cart');

      if (onPage) {
        this.renderPage(state, pageSections);
        form.closest('.nv-upsell__item')?.remove();
        if (!this.querySelector('.nv-upsell__item')) this.closest('.nv-upsell-page')?.remove();
        this.announce();
      } else {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        setTimeout(() => {
          drawer.querySelector('.drawer__inner')?.focus({ preventScroll: true });
          const live = document.getElementById('CartDrawer-LiveRegionText');
          if (live) live.textContent = this.dataset.added || '';
        });
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: onPage ? 'cart-items' : 'nuvian-cart-upsell', productVariantId: id, cartData: state });
      }
    } catch (err) {
      const status = this.querySelector('[data-upsell-status]');
      if (status) status.textContent = window.cartStrings?.error || '';
      button.removeAttribute('aria-disabled');
    } finally {
      button.classList.remove('loading');
      form.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }

  pageSections() {
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    return [
      items && { id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      footer && { id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' },
    ].filter(Boolean);
  }

  renderPage(state, list) {
    list.forEach(({ id, section, selector }) => {
      const html = state.sections?.[section];
      const host = document.getElementById(id);
      if (!html || !host) return;
      const src = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      const dest = host.querySelector(selector) || host;
      if (src) dest.innerHTML = src.innerHTML;
    });
    document.querySelectorAll('cart-items, #main-cart-footer').forEach((el) => el.classList.remove('is-empty'));
  }

  announce() {
    const status = this.querySelector('[data-upsell-status]');
    if (status) status.textContent = this.dataset.added || '';
  }
});
// Ligne tout juste ajoutée : fond signature qui s'estompe (CSS, rien sous reduced-motion).
if (!window.nvNewLine && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  window.nvNewLine = 1;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
    const c = e?.cartData;
    if (!c || e.source === 'cart-items') return;
    const ids = (c.items || [c]).map((i) => i.variant_id || i.id);
    const mark = (n) =>
      ids.forEach((id) =>
        document.querySelectorAll(`#CartDrawer [data-variant-id="${id}"]`).forEach((r) => r.classList.add('nv-new'))
      ) || (n && !document.querySelector('#CartDrawer .nv-new') && setTimeout(() => mark(0), 350));
    requestAnimationFrame(() => mark(1));
  });
}
